module.exports = __webpack_public_path__ + "static/media/tm.cc63fa32.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tm.svg
// module id = 2227
// module chunks = 0